import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Social from '../components/Social';
import PricingPlans from '../components/PricingPlans';

import demoVideo from '../assets/images/demo.gif';
import gplay from '../assets/images/google-play-badge.svg';
import astore from '../assets/images/app-store-badge.svg';
import Testimonials from '../components/Testimonials';
import RecentStats from '../components/RecentStats';
import Banner from '../components/Banner';
import InstagramEmbed from '../components/InstagramEmbed';
import LatestBlogPosts from '../components/LatestBlogPosts';

const IndexPage = ({ data }) => {
  const posts = (data && data.api && data.api.blogPosts) || [];

  return (
    <Layout>
    <style>{`
      .testimonials-section .section-heading h2 {
        color: rgba(255, 255, 255, 0.95);
      }
      .testimonials-section .section-heading p {
        color: rgba(255, 255, 255, 0.75);
        font-size: 1.1rem;
        letter-spacing: normal;
      }
      .testimonials-section hr {
        border-color: rgba(255, 255, 255, 0.3);
      }
      .testimonials-section #testimonials blockquote cite {
        color: rgba(255, 255, 255, 0.75);
        font-style: normal;
      }
    `}</style>
    <Header />

    <header className="masthead text-center" id="top">
      <Banner />
      <div className="container">
        <div className="row h-100">
          <div className="col-lg-7 my-auto">
            <div className="header-content mx-auto">
              <h1 className="mb-4">Focus on the effort</h1>
              <p className="lead mb-4">
                Program any workout in seconds, train with real-time metrics,
                and make every meter count. ErgZone automates workout
                programming and data collection by connecting your device
                directly to your equipment. Discover training plans from
                coaches, join community challenges, and analyze your performance
                with precision.
              </p>
              <a href="#download" className="btn btn-outline btn-xl">
                Download Now for Free!
              </a>
            </div>
          </div>
          <div className="col-lg-5 my-auto">
            <div
              style={{
                position: 'relative',
                aspectRatio: '9/16',
                maxWidth: '325px',
                margin: '0 auto',
                overflow: 'hidden',
                borderRadius: '12px',
              }}
            >
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  borderRadius: '12px',
                }}
                src="https://www.youtube.com/embed/-2ee7Ataf7c?rel=0"
                title="ErgZone Demo Video"
                referrerpolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                frameBorder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section
      id="stats"
      style={{
        background: '#1a1a1a',
      }}
    >
      <div className="container">
        <div className="row">
          <div className="mx-auto">
            <h2 className="section-heading" style={{ color: 'white' }}>
              Who is using ErgZone?
            </h2>
          </div>
          <RecentStats />
        </div>
      </div>
    </section>

    <section className="features" id="features">
      <div className="container">
        <div className="section-heading text-center">
          <h2>Amazing Features</h2>
          <p className="text-muted">Check out what you can do with ErgZone!</p>
          <hr />
        </div>
        <div className="row">
          <div className="col-lg-4 my-auto">
            <div className="device-container">
              <div className="device-mockup iphone6_plus portrait white">
                <div className="device">
                  <div className="screen">
                    <img src={demoVideo} className="img-fluid" alt="" />
                  </div>
                  <div className="button"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 my-auto">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <div className="feature-item">
                    <i className="icon-present text-primary"></i>
                    <h3>Data</h3>
                    <p className="text-muted">
                      See live HR%, Zones, Target Pace/Rate, SPI, DF, Watts,
                      Force Curve from previous, current and next
                      intervals/splits.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="feature-item">
                    <i className="icon-lock-open text-primary"></i>
                    <h3>Custom Workouts</h3>
                    <p className="text-muted">
                      Create unlimited custom workouts and build your own
                      library.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="feature-item">
                    <i className="icon-present text-primary"></i>
                    <h3>Rankings And Challenges</h3>
                    <p className="text-muted">
                      Compare your results with other athletes and see your
                      standing among your peers.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="feature-item">
                    <i className="icon-lock-open text-primary"></i>
                    <h3>Platform for Coaches</h3>
                    <p className="text-muted">
                      Manage workouts, athletes, and competitions in one single
                      place.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="feature-item">
                    <i className="icon-screen-smartphone text-primary"></i>
                    <h3>Discover Content</h3>
                    <p className="text-muted">
                      Get free workouts from partner coaches, find the perfect
                      training plan or start your monthly programming.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="feature-item">
                    <i className="icon-camera text-primary"></i>
                    <h3>Concept2 Logbook</h3>
                    <p className="text-muted">
                      Workouts are automatically uploaded to C2 Logbook and
                      marked as verified.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      className="testimonials-section text-center"
      id="testimonials"
      style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        color: 'white',
      }}
    >
      <div className="container">
        <div className="section-heading">
          <h2>What athletes and coaches are saying</h2>
          <p>Trusted by rowing clubs, gyms, and coaches worldwide</p>
          <hr />
        </div>
        <Testimonials />
      </div>
    </section>

    <PricingPlans />

    <section className="download bg-primary text-center" id="download">
      <div className="container">
        <div className="row">
          <div className="col-md-8 mx-auto">
            <h2 className="section-heading">Download ErgZone on your device</h2>
            <p>Free on iOS and Android.</p>
            <div className="badges">
              <a
                className="badge-link plausible-event-name=Download+Click"
                href="https://android.erg.zone"
              >
                <img src={gplay} alt="" />
              </a>
              <a
                className="badge-link plausible-event-name=Download+Click"
                href="https://apple.erg.zone"
              >
                <img src={astore} alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <LatestBlogPosts posts={posts} />

    <section className="contact bg-white" id="contact">
      <div className="container">
        <h2>
          We <i className="fas fa-heart"></i> new friends!
        </h2>
        <Social />
      </div>
      <InstagramEmbed />
    </section>

      <Footer />
    </Layout>
  );
};

export const pageQuery = graphql`
  query HomeBlogPosts {
    api {
      blogPosts {
        id
        title
        slug
        excerpt
        publishedAt
        imageUrl
      }
    }
  }
`;

export default IndexPage;
